export default __webpack_public_path__ + "static/media/termsImageDesktop.cee15530.png";